import Splide from '@splidejs/splide';
window.splide = Splide;
window.lightbox = require('simple-lightbox');

import { categorySelect } from "./modules/categorySelect";
import { initFaq } from '../../includes/blocks/block-faq/script';
import { initScrollableTabs, changeTabContent } from "./modules/scrollableTabs";
import {navInit, initSearchModal, initMegaMenu, initHeaderBar} from './modules/navigation';
import { productViewSwitch } from './modules/productViewSwitch';
import { initRecommendedSlider } from "./modules/productRecommendedSlider";
import { videoBulletsYTPlayerInit } from '../../includes/blocks/block-video-bullets/script';
import { videoBulletsHTMLPlayerInit } from '../../includes/blocks/block-video-bullets/script';
import { textVideoBulletsYTPlayerInit } from '../../includes/blocks/block-text-video-bullets/script';
import { initFeaturedCategoriesSlider } from './modules/featuredCategoriesSlider';
import { productCategoryList } from './modules/productCategoryList';
import { productCategoryModal } from './modules/productCategoryModal';
import { productFilterModal } from './modules/productFilterModal';
import { productCustomGallery } from './modules/productCustomGallery';
import { selectProductVariant } from './modules/productVariations';
import { toggleReviewPopup } from "./modules/toggleReviewPopup";
import { formInvoiceInput } from './modules/formInvoiceInput';
import { initTabsContent } from './modules/tabsContent';
import { initCompanyPrivRadio } from "./modules/companyPrivRadio";
import { loginFormModalInit } from "./modules/checkoutLoginForm";
import { checkoutRadioBtns } from "./modules/checkoutRadioBtns";
import { viewedProducts } from "./modules/viewedProducts";
import { initHeroSlider } from '../../includes/blocks/block-hero/script';
import { initBrandsSlider } from '../../includes/blocks/block-brand-logos/script';
import { selectingTireOptions, initTireSearch } from '../../includes/blocks/block-tires-search/script';
import { initRecentProductsSlider } from "./modules/recentProductsSlider";
import { initLoginError } from "./modules/loginError";

navInit();
initHeaderBar();

//change cart quantity
function incrementCart() {
  const updateButton = document.querySelector(".actions>button");
  this.parentNode.querySelector(`input.text`).stepUp();
  updateButton.disabled = false;
  updateButton.click();
}
function decrementCart() {
  const updateButton = document.querySelector(".actions>button");
  this.parentNode.querySelector(`input.text`).stepDown();
  updateButton.disabled = false;
  updateButton.click();
}
function listenOnCart() {
  const arrowsUp = document.querySelectorAll(".qty_button.plus");
  const arrowsDown = document.querySelectorAll(".qty_button.minus");
  for (const arrow of arrowsUp) {
    arrow.onclick = incrementCart;
  }
  for (const arrow of arrowsDown) {
    arrow.onclick = decrementCart;
  }
}
listenOnCart();
const config = { attributes: true, childList: true, subtree: true };
const observer = new MutationObserver(listenOnCart);
observer.observe(document, config);


/**
 * Disable WPCF7 button while it's submitting
 * Stops duplicate enquiries coming through
 */
if (document.querySelector('form.wpcf7-form')) {
  const formCF7 = document.querySelector('form.wpcf7-form');
  document.addEventListener('wpcf7submit', function (event) {

    // find only disbaled submit buttons
    const button = formCF7.querySelector('.wpcf7-submit[disabled]');

    // grab the old value
    const old_value = button.getAttribute('data-value');

    // enable the button
    button.removeAttribute('disabled');

    // put the old value back in
    button.value = old_value;

  }, false);

  formCF7.addEventListener('submit', function () {
    if (formCF7.querySelector('.ajax-loader')) formCF7.querySelector('.ajax-loader').remove();

    const button = formCF7.querySelector('input[type=submit]');
    const current_val = button.value;

    // store the current value so we can reset it later
    button.setAttribute('data-value', current_val);

    // disable the button
    button.setAttribute("disabled", true);

    // tell the user what's happening
    button.value = "Wysyłanie...";

  });
}


if (document.querySelector('.blogPage')) {
  categorySelect();
}

if (document.querySelector('.blockFaq')) {
  initFaq();
}

if (document.querySelector('.scrollableTabs')) {
  initScrollableTabs();

  if (document.querySelector('.scrollableTabs').classList.contains('scrollableTabs--withContent')) {
    changeTabContent();
  }
}

if (document.querySelector('.customArchiveProduct__loop')) {
  productViewSwitch();
}

if (document.querySelector('.recommendedProducts__slider')) {
  initRecommendedSlider();
}

if (document.querySelector('#videoBulletsYTPlayer')) {
  videoBulletsYTPlayerInit();
}

if (document.querySelector('#videoBulletsHTMLPlayer')) {
  videoBulletsHTMLPlayerInit();
}

if (document.querySelector('#textVideoBulletsYTPlayer')) {
  textVideoBulletsYTPlayerInit();
}

if (document.querySelector('.featuredCategories__slider')) {
  initFeaturedCategoriesSlider();
}

if (document.querySelector('.customArchiveProduct__category')) {
  productCategoryList();
  productCategoryModal();
  productFilterModal();
}

if (document.querySelector('.variantList')) {
  selectProductVariant();
}

if (document.querySelector('.productCustomGallery')) {
  productCustomGallery();
}

if (document.querySelector('#reviewPopupOpen')) {
  toggleReviewPopup();
}

if (document.querySelector('#invoice')) {
  formInvoiceInput();
}

if (document.querySelector('.searchModal')) {
  initSearchModal();
}

if (document.querySelector('.tabsContent')) {
  initTabsContent();
}

if (document.querySelector('.customCheckoutPage__billing')) {
  initCompanyPrivRadio();
}

if (document.querySelector('.customCheckoutPage__login')) {
  loginFormModalInit();
}

if (document.querySelector('#shipping_method')) {
  checkoutRadioBtns();
}

if (document.querySelector('#viewedId')) {
  viewedProducts();
}

if (document.querySelector('.blockHero__slider')) {

  initHeroSlider();
}

if (document.querySelector('.submenu-category__left')) {
  initMegaMenu();
}

if (document.querySelector('.blockBrandLogos__slider')) {
  initBrandsSlider();
}

if (document.querySelector('.blockTiresSearch')) {
  selectingTireOptions();
  initTireSearch();
}

if (document.querySelector('.blockRecentProducts__slider')) {
  initRecentProductsSlider();
}

if (document.querySelector('.page-id-9')) {
  initLoginError();
}

jQuery(document).ready(function () {
  jQuery('#billing_nip').on('input', function () {
    let inputValue = jQuery(this).val().replace(/\D/g, '');

    if (inputValue.length > 10) {
      inputValue = inputValue.slice(0, 10);
    }

    jQuery(this).val(inputValue);
  });
});

jQuery(document).ready(function () {
  jQuery('#billing_phone').on('input', function () {
    let inputValue = jQuery(this).val().replace(/\D/g, '');

    if (inputValue.length > 9) {
      inputValue = inputValue.slice(0, 9);
    }

    jQuery(this).val(inputValue);
  });
});

jQuery(document).ready(function () {
  jQuery('#billing_postcode').on('input', function () {
    var postcode = jQuery(this).val().replace(/\D/g, '');

    if (postcode.length > 6) {
      postcode = postcode.slice(0, 6);
    }

    if (postcode.length >= 3 && postcode.indexOf('-') === -1) {
      postcode = postcode.slice(0, 2) + '-' + postcode.slice(2);
    }

    if (/^\d{2}-\d{3}$/.test(postcode)) {
      jQuery(this).val(postcode);
    } else {
      jQuery(this).val(postcode.slice(0, 6));
    }
  });
});

jQuery(document.body).on('checkout_error', function() {
      if (jQuery('.woocommerce-error').length) {
          jQuery('html, body').animate({
              scrollTop: (jQuery('html').first().offset().top - 50)
          }, 1000);
      }
  });